require('./$.species')(Array);


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/~/babel-core/~/core-js/modules/es6.array.species.js
 ** module id = 175
 ** module chunks = 0
 **/